import React from 'react';
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/rdGaSNuUNocnKER58rG4Jy/ChatGPT_Image_4_ago_2026,_09_16_03.png';
type LogoProps = {
  tone?: 'dark' | 'light';
  className?: string;
};

/**
 * The uploaded brand asset is a square lockup on a white plate. We crop the
 * isotype ("A") out of it and pair it with the Almaria wordmark.
 */
export function Logo({
  tone = 'dark',
  className = ''
}: LogoProps) {
  const text = tone === 'dark' ? 'text-ink' : 'text-white';
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-80" data-mp="rsh4ci6cvlo7">
      <span aria-hidden="true" className="h-9 w-9 shrink-0 rounded-xl bg-white bg-no-repeat" style={{
      backgroundImage: `url("${LOGO_URL}")`,
      backgroundSize: '238% 238%',
      backgroundPosition: '50% 30%'
    }} data-id="element-81" data-mp="rpl76w2c110t" />
      <span className={`text-[19px] font-semibold tracking-[0.06em] ${text}`} data-id="element-82" data-mp="2ygu4so7jrdx4">ALMARIA</span>
    </span>;
}